function Container(props) {
	return <div className="container p-4">{props.children}</div>;
}

export default Container;
